import { createFileRoute } from "@tanstack/react-router";
import CommunityLayout from "lib/components/builders/communities/CommunityLayout";
import OptionCatalogLocationPage from "lib/components/options/catalog/search/OptionCatalogLocationPage";
import OptionCatalogStateProvider from "lib/components/options/catalog/utils/optionCatalogStateProvider";
import withAuthentication from "../../../../../../components/withAuthentication";

function OptionsPageInner() {
  return (
    <CommunityLayout currentPage="options">
      <OptionCatalogLocationPage />
    </CommunityLayout>
  );
}

function OptionsPage() {
  return (
    <OptionCatalogStateProvider>
      <OptionsPageInner />
    </OptionCatalogStateProvider>
  );
}

export const Route = createFileRoute("/builders/$builder_id/locations/$location_id/options/")({
  component: withAuthentication(OptionsPage, {
    permissions: ["VIEW_OPTION_CATALOG", "VIEW_LOCATION_OPTIONS"],
    permissionOperator: "AND",
    features: ["nextGenOptions", "nextGenOptionsLocation"],
  }),
});
